import { render, staticRenderFns } from "./ShowImage.vue?vue&type=template&id=c8ea56de&scoped=true&"
import script from "./ShowImage.vue?vue&type=script&lang=js&"
export * from "./ShowImage.vue?vue&type=script&lang=js&"
import style0 from "./ShowImage.vue?vue&type=style&index=0&id=c8ea56de&lang=scss&scoped=true&"
import style1 from "./ShowImage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ea56de",
  null
  
)

export default component.exports